import { render, staticRenderFns } from "./ChatBoosterTreinamento.vue?vue&type=template&id=6846763f&scoped=true&"
import script from "./ChatBoosterTreinamento.vue?vue&type=script&lang=js&"
export * from "./ChatBoosterTreinamento.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoosterTreinamento.vue?vue&type=style&index=0&id=6846763f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6846763f",
  null
  
)

export default component.exports